
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12138',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12138",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.464",
  "dashboard-client-types": "static-1.360",
  "data-fetching-client": "static-1.9639",
  "foundations-components": "static-1.7859",
  "foundations-components-legacy": "static-1.884",
  "foundations-theming": "static-1.4383",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7981",
  "hub-http-shared-msw-handlers": "static-1.9875",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11428",
  "I18n": "static-7.1615",
  "jasmine-runner": "static-1.6434",
  "marketplace-storefront-base": "static-1.12199",
  "quartz": "static-1.6975",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "reactive-variable-buffer-atom": "static-1.2825",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.64",
  "settings-ui-lib": "static-1.12487",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7067",
  "ui-addon-i18n": "static-1.11116",
  "ui-addon-react-router-dom": "static-1.9511",
  "unified-auth": "static-1.444",
  "unified-auth-core-lib": "static-1.725",
  "usage-tracker": "static-1.7304",
  "usage-tracker-core": "static-1.7154",
  "customer-data-property-utils": "static-1.8049",
  "hub-http": "static-1.6188",
  "integrations-lib": "static-1.16005",
  "marketplace-ui-common": "static-1.19588",
  "property-management-iframe": "static-1.13026",
  "quartz-config": "static-1.753",
  "quartz-core": "static-1.6194",
  "quartz-routing": "static-1.405",
  "quick-fetch": "static-1.3887",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4617",
  "ts-schema": "static-1.4049",
  "ui-universal-auth": "static-1.8930",
  "UIComponents": "static-3.8375",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3375",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3252",
  "quartz-webpack": "static-1.3199",
  "bend-plugin-quartz-routing": "static-1.53",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4128",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4824",
  "foundations-theming-specialty": "static-1.2099",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9395",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5315",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1753",
  "ui-fonts": "static-1.690",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-theming": "static-1.2866",
  "foundations-theming-base": "static-1.3368",
  "stylex": "static-1.32",
  "HeadJS": "static-2.742",
  "hs-test-utils-bend-plugin": "static-1.3092",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4292",
  "ai-components-ui-library": "static-1.8846",
  "ai-rendering-library": "static-1.9998",
  "chirp-fetch": "static-1.1853",
  "connections-embed-lib": "static-1.926",
  "copilot-toolkit": "static-1.11039",
  "feedback-loader": "static-1.29229",
  "laboratory-lib": "static-3.7125",
  "marketplace-embed": "static-1.21978",
  "marketplace-ui-details": "static-1.9484",
  "marketplace-ui-reviews": "static-1.19544",
  "marketplace-ui-tracking": "static-1.13759",
  "sanitize-text": "static-1.8109",
  "ui-addon-video-player": "static-1.8664",
  "usage-tracker-multi": "static-1.5718",
  "usage-tracker-session-replay": "static-1.4990",
  "wootric-nps": "static-1.6950",
  "quartz-head": "static-1.640",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4616",
  "immer": "static-1.33",
  "immerable": "static-1.4120",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2481",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.64",
  "cssUtils": "static-1.782",
  "flux-actions": "static-1.331",
  "HubStyle": "static-2.11736",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10177",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10337",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7294",
  "icons": "static-2.644",
  "marketplace-ui-apps-core": "static-1.18121",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4481",
  "foundations-components-test-utils": "static-1.5342",
  "quartz-i18n": "static-1.650",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.131",
  "microsoft-drive-integration-lib": "static-1.248",
  "fsm": "static-1.3698",
  "customer-data-objects": "static-1.7629",
  "property-translator": "static-1.5367",
  "hs-locale-management": "static-1.55",
  "frontend-preferences-client": "static-1.7895",
  "hs-promise-utils": "static-1.5559",
  "hubspot-apollo-client": "static-1.4842",
  "integrations-error-boundary-lib": "static-1.13420",
  "integrations-tracking-lib": "static-1.5565",
  "native-integrations-shared-strings": "static-1.7749",
  "reselect": "static-2.16",
  "sanitize": "static-1.4438",
  "superstore": "static-1.4732",
  "ui-shepherd-react": "static-3.10118",
  "ai-settings-ui-library": "static-1.7826",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4623",
  "immutable-less": "static-1.4615",
  "marketplace-ui-client-types": "static-1.16995",
  "nav-meta": "static-1.29553",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10212",
  "ui-addon-upgrades": "static-9.17936",
  "inbound-db-properties-service-client": "static-1.3811",
  "property-management-common": "static-1.5314",
  "ui-addon-iframeable": "static-1.9024",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.516",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.650",
  "quartz-test": "static-1.650",
  "quartz-tracking": "static-1.354",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.27",
  "bender-build-tools": "static-1.3147",
  "inbound-db-meta-service-client": "static-1.3561",
  "persist-promise": "static-1.3667",
  "reference-resolvers": "static-1.8136",
  "transmute": "static-2.85",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21125",
  "ContentUtils": "static-1.68256",
  "customer-data-objects-ui-components": "static-1.12992",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2465",
  "customer-data-filters-ui": "static-1.39631",
  "customer-data-reference-ui-components": "static-1.13126",
  "embedded-academy-lib": "static-1.14231",
  "ExportDialog": "static-6.10360",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41202",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.64",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.64",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.64",
  "ui-addon-teams": "static-1.21499",
  "magpie-lib": "static-1.5536",
  "navigation-components": "static-1.17916",
  "magpie-types": "static-1.4996",
  "simple-logging-lib": "static-1.3015",
  "ai-studio-lib": "static-1.11504",
  "app-governance-lib": "static-1.1434",
  "developer-experience-shared-components": "static-1.10476",
  "ui-addon-integrations-directory-panel": "static-2.7963",
  "ui-product-approvals": "static-1.28031",
  "ui-tool-access": "static-1.10116",
  "usage-based-billing-components-lib": "static-1.8702",
  "usage-tracker-anonymous": "static-1.5721",
  "usage-tracker-public": "static-1.7115",
  "amplitude-session-replay-browser": "static-1.59",
  "ui-extensibility-client-types": "static-1.3892",
  "hubspot-apollo-cache": "static-1.301",
  "universal-page-editor-lib": "static-1.2979",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2674",
  "merchandise-lib": "static-1.262",
  "atom": "static-1.5038",
  "purchase-motions-components": "static-1.5817",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1510",
  "crm-component-utils": "static-1.38988",
  "crm-properties-common-lib": "static-1.5842",
  "customer-data-properties": "static-1.51423",
  "framework-data-schema-resolvers": "static-1.6846",
  "property-value-citations": "static-1.2037",
  "reference-resolvers-lite": "static-1.8061",
  "navigation-messaging": "static-1.7243",
  "hubspotter-http-shared-msw-handlers": "static-1.9873",
  "growth-payments-core": "static-1.25271",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13568",
  "conversations-skeleton-state": "static-1.7215",
  "crm-message-bus": "static-1.42895",
  "reporting-plugins": "static-1.10258",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.64",
  "cms-field-types": "static-1.4778",
  "content-icons-ui": "static-1.2216",
  "customer-data-ui-utilities": "static-1.9793",
  "customer-data-filters-ui-msw-helpers": "static-1.22066",
  "FormUrlGenerator": "static-2.4685",
  "framework-builder-read-service-client": "static-1.3980",
  "framework-data-schema-quick-fetch": "static-1.6751",
  "multi-account-reference-resolvers": "static-1.945",
  "onboarding-tours": "static-1.16529",
  "academy-common-lib": "static-1.13691",
  "content-assistance-lib": "static-1.7696",
  "dashboard-lib": "static-1.81388",
  "file-manager-components": "static-1.23517",
  "getting-started-shared-tasks": "static-1.18402",
  "hubspot-prosemirror": "static-1.18145",
  "hubspot-prosemirror-plugins": "static-1.18137",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19768",
  "share-with-third-party-component-lib": "static-1.8664",
  "ui-addon-draggable": "static-3.4735",
  "ui-asset-management-lib": "static-1.10977",
  "ui-business-units-lib": "static-1.9015",
  "user-context": "static-1.5069",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.689",
  "nest": "static-1.193",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10592",
  "framework-listing-lib": "static-2.28590",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30631",
  "apps-service-types": "static-1.3844",
  "oauth-service-types": "static-1.4217",
  "onboarding-scopes": "static-1.6428",
  "onboarding-tours-client": "static-1.4743",
  "platform-infra-nav-components": "static-1.7644",
  "subscription-experience-data-types": "static-1.14875",
  "crm-record-cards-service-types": "static-1.3579",
  "location-customization-utils-lib": "static-1.9145",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5820",
  "signup-constants": "static-1.18780",
  "signup-ui-url-generator": "static-2.8007",
  "trials-service-types": "static-1.3870",
  "card-properties-lib": "static-1.44072",
  "commerce-subscription-lib": "static-1.37004",
  "crm-actions": "static-1.6288",
  "crm-cards-sdk": "static-1.43477",
  "customer-data-properties-shared-msw-handlers": "static-1.9202",
  "customer-data-tracking": "static-1.6852",
  "hs-resources": "static-1.117",
  "pulse": "static-1.530",
  "calling-global-api": "static-1.64389",
  "calling-internal-common": "static-1.31268",
  "calling-lifecycle-internal": "static-1.65771",
  "calling-lifecycle-messages": "static-1.58065",
  "commerce-products-lib": "static-1.9410",
  "conditional-properties-service-client": "static-1.3768",
  "crm-links": "static-1.6251",
  "external-options-client-types": "static-1.4129",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4194",
  "meetings-icalendar-utils-lib": "static-1.598",
  "multi-currency-client-types": "static-1.3662",
  "object-builder-ui-client": "static-1.48617",
  "pipeline-validation-client-types": "static-1.3936",
  "smart-property-lib": "static-1.6738",
  "tiered-pricing": "static-1.1127",
  "ui-addon-form-validation": "static-1.10954",
  "crm-pipelines-api-client-types": "static-1.4113",
  "ui-addon-opt": "static-4.8337",
  "campaign-roi-lib": "static-1.8989",
  "react-dnd-compat": "static-1.4586",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5371",
  "growth-onboarding-confetti": "static-1.3033",
  "growth-onboarding-next-action-utils": "static-1.1818",
  "onboarding-tours-utils": "static-1.595",
  "ui-shepherd-tracker": "static-1.7499",
  "academy-service-client": "static-1.3649",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39016",
  "FileManagerLib": "static-1.39157",
  "video-embed": "static-1.35643",
  "zustand": "static-1.74",
  "ui-coaching-tips": "static-1.28446",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11151",
  "video-data-lib": "static-1.34809",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23435",
  "ui-addon-emoji-picker": "static-1.9854",
  "EmailSignatureEditor": "static-1.24292",
  "viral-links-lib": "static-1.7022",
  "data-token-picker": "static-1.16342",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.191",
  "timezone-utils": "static-2.5211",
  "getting-started-shared-tasks-store": "static-1.17520",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7291",
  "customer-data-views-management": "static-1.25380",
  "framework-data-table": "static-2.11834",
  "marketing-platform-lib": "static-1.6818",
  "nudge-client-utils": "static-1.2484",
  "nudge-custom-ui-functions": "static-1.970",
  "app-users-service-client": "static-1.5560",
  "app-users-service-types": "static-1.4968",
  "mini-checkout-client": "static-1.26714",
  "onboarding-utils": "static-1.5319",
  "permissions-shared-i18n-strings-fe": "static-1.2044",
  "ui-coaching-tips-shared-config": "static-1.28431",
  "edison-service-client-types": "static-1.354",
  "crm_data": "static-4.91846",
  "customer-data-sidebar": "static-2.45911",
  "enrichment-properties-lib": "static-1.15856",
  "commerce-billing-lib": "static-1.18963",
  "commerce-shared-components-lib": "static-1.18429",
  "commerce-tools-ui-lib": "static-1.10274",
  "crm-fe-perf": "static-1.22869",
  "bend-plugin-pulse": "static-1.33",
  "directed-graph": "static-1.901",
  "event-emitter": "static-1.914",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31274",
  "shared-worker-versioning": "static-1.11004",
  "calling-usage-tracker": "static-1.6509",
  "voice-sms-access-library": "static-1.841",
  "commerce-permissions": "static-1.732",
  "products-iframe-lib": "static-1.7834",
  "products-ui-components-shared-msw-handlers": "static-1.10257",
  "data-agent-kit": "static-1.136",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9958",
  "policy-lib": "static-1.6740",
  "react-tinymce": "static-1.55138",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10021",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54264",
  "tinymce-plugins": "static-1.57378",
  "tinymce-themes": "static-1.56234",
  "breeze-engine-lib": "static-1.489",
  "onboarding-data-sync-lib": "static-1.1901",
  "growth-onboarding-next-action-components": "static-1.1846",
  "user-context-client": "static-1.4578",
  "audio-components": "static-1.5861",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36668",
  "urlinator": "static-1.4497",
  "video-components": "static-1.13154",
  "outpost": "static-1.4152",
  "growth-onboarding-feedback-components": "static-1.6549",
  "content-media-composition-data-lib": "static-1.12136",
  "content-media-compositions": "static-2.16143",
  "media-bridge-lib": "static-1.18864",
  "commerce-tours-lib": "static-1.6026",
  "growth-onboarding-reliability": "static-1.5049",
  "sales-checkout-service-client": "static-1.3606",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21608",
  "sales-email-signature-service-client": "static-1.3810",
  "ts-utils-lib": "static-1.139",
  "crm-export-dialog": "static-1.6265",
  "crm-index-associations-lib": "static-1.6405",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1878",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2241",
  "nudge-renderer-utils": "static-1.2560",
  "whisper-core-api": "static-1.6510",
  "InboxConnectUtils": "static-4.14714",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5422",
  "settings-content-modals": "static-1.45975",
  "crm_universal": "static-1.21943",
  "customer-data-email": "static-1.17970",
  "card-payment-highlight-lib": "static-1.37064",
  "card-subscription-highlight-lib": "static-1.39427",
  "commerce-contract-lib": "static-1.11917",
  "invoices-highlight-card-lib": "static-1.54606",
  "orders-highlight-card-lib": "static-1.21370",
  "products-highlight-card-lib": "static-1.17694",
  "quotes-highlight-card-lib": "static-1.71879",
  "crm-source-interpretation-lib": "static-1.5305",
  "utility-belt": "static-1.2503",
  "payments-enrollment-embed-lib": "static-1.22634",
  "stripe-embedded-components": "static-1.7439",
  "customer-data-rte": "static-1.32897",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5653",
  "payments-post-enroll-local-storage-lib": "static-1.5075",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.37969",
  "calling-orchestration-schema": "static-1.35618",
  "sales-views-client-types": "static-1.4231",
  "hub-http-contrib": "static-1.3006",
  "interframe": "static-3.4727",
  "tinymce-data": "static-1.40349",
  "ui-addon-sales-email": "static-1.5177",
  "layout-dnd-components": "static-1.12373",
  "layout-dnd-utils": "static-1.11348",
  "ui-brand-identity-lib": "static-1.15113",
  "NamespacedHubStyle": "static-2.9033",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.21995",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1882",
  "checkout-sdk": "static-3.23557",
  "checkout-service-types": "static-1.3797",
  "company-details-components": "static-1.6163",
  "payment-method-components": "static-1.6879",
  "pricing-pages-ui-components": "static-1.13763",
  "quote-checkout-service-types": "static-1.3442",
  "upgrade-catalog-service-types": "static-1.3491",
  "access-control-lib": "static-1.10403",
  "EmailComponents": "static-1.54674",
  "EmailData": "static-1.53351",
  "redux-less": "static-2.9449",
  "sequences-lib": "static-1.7977",
  "ui-gdpr-components": "static-1.10314",
  "products-ui-components": "static-1.39929",
  "accounting-integrations-ui-components": "static-1.7006",
  "invoices-ui-lib": "static-1.54622",
  "commerce-products-api": "static-1.2233",
  "invoices-iframe-lib": "static-1.56680",
  "quotes-modal-lib": "static-1.102557",
  "quotes-ui-lib": "static-1.80600",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28165",
  "ContentData": "static-1.68331",
  "layout-data-lib": "static-1.9673",
  "hub-http-rxjs": "static-1.794",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3899",
  "billing-payments-client-types": "static-1.3957",
  "react-performance-metrics-lib": "static-1.525",
  "account-and-billing-fintech-outages": "static-3.18529",
  "pricing-pages-api": "static-1.13628",
  "ContentComponents": "static-2.71212",
  "marketing-contacts-lib": "static-1.9876",
  "marketing-email-service-types": "static-1.1897",
  "messaging-editing-lib": "static-1.46158",
  "messaging-usage-based-billing-components-lib": "static-1.1020",
  "automation-ui-source-apps": "static-1.18764",
  "automation-ui-types": "static-1.19682",
  "messaging-types-lib": "static-1.45895",
  "onboarding-settings-client": "static-1.4469",
  "sequences-client-types-lib": "static-1.7834",
  "commerce-tax-lib": "static-1.490",
  "price-books-api": "static-1.526",
  "price-books-components": "static-1.584",
  "property-description-translator": "static-1.3812",
  "ramp-editor": "static-1.61",
  "commerce-analytics-service-client": "static-1.3594",
  "totals-ui-components": "static-1.23494",
  "SalesContentIndexUI": "static-3.9188",
  "advanced-menus-core": "static-1.15072",
  "advanced-menus-lib": "static-1.12019",
  "ui-memberships-settings-lib": "static-1.33946",
  "segments-query-core": "static-1.1380",
  "demographics-service-types": "static-1.1619",
  "eligibility-engine-service-types": "static-1.3151",
  "automation-ui-ubb": "static-1.5598",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7305",
  "data-token-views": "static-1.16323",
  "forms-utils-lib": "static-1.12510",
  "payments-embed-points-lib": "static-1.12953",
  "simple-menus-core": "static-1.15071",
  "simple-menus-lib": "static-1.16588",
  "ui-addon-draggable-compat": "static-2.4221",
  "videoconference-integration-components": "static-1.6765",
  "marketing-contacts-client": "static-1.7484",
  "automation-applications-service-types": "static-1.3469",
  "automation-platform-service-types": "static-1.2570",
  "ContentEditorUI": "static-2.77014",
  "short-messages-app-service-client": "static-1.3948",
  "web-interactives-components": "static-1.13697",
  "web-interactives-data": "static-1.13698",
  "messaging-shared-utils-lib": "static-1.469",
  "messaging-user-info-utils-lib": "static-1.639",
  "email-portal-health-service-types": "static-1.943",
  "line-items-api": "static-1.634",
  "commerce-totals-service-types": "static-1.3789",
  "FireAlarmUi": "static-1.4484",
  "sales-templates-service-types-lib": "static-1.4139",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21618",
  "automation-ui-usage-tracking": "static-1.21081",
  "data-studio-ubb": "static-1.2612",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26937",
  "collaboration-sidebar": "static-1.57694",
  "content-management-data-lib": "static-1.5339",
  "copilot-plugins": "static-1.11012",
  "cta-picker": "static-1.36303",
  "customer-agent-discovery-components-lib": "static-1.2986",
  "editor-components": "static-1.13179",
  "editor-iframe-lib": "static-1.8351",
  "error-messaging-js": "static-1.5158",
  "FormsCommonComponents": "static-1.85743",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10612",
  "SharedLegalStrings": "static-1.1713",
  "smart-content-core": "static-1.42335",
  "smart-content-lib": "static-1.42988",
  "social-composer-lib": "static-1.58954",
  "structured-content-lib": "static-1.25093",
  "theme-previewer-lib": "static-1.53151",
  "tinymce-copilot": "static-1.16332",
  "xray-recommendation-lib": "static-1.7851",
  "automation-ui-routing": "static-1.21039",
  "sql-reporting-client-types": "static-1.5606",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42112",
  "campaigns-utils-lib": "static-1.3139",
  "reporting-enablement": "static-1.22791",
  "chatspot-widget-iframe": "static-1.21116",
  "collaboration-sidebar-common": "static-1.2491",
  "forms-ai-lib": "static-1.4259",
  "codemirror-dlb": "static-1.58573",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6396",
  "report-customization-components": "static-1.13060",
  "data-quality-ui-library": "static-1.12880",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.242",
  "reporting-insights-lib": "static-1.1636"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12138",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.464",
  "dashboard-client-types": "/dashboard-client-types/static-1.360",
  "data-fetching-client": "/data-fetching-client/static-1.9639",
  "foundations-components": "/foundations-components/static-1.7859",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.884",
  "foundations-theming": "/foundations-theming/static-1.4383",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7981",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9875",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11428",
  "I18n": "/I18n/static-7.1615",
  "jasmine-runner": "/jasmine-runner/static-1.6434",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12199",
  "quartz": "/quartz/static-1.6975",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2825",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.64",
  "settings-ui-lib": "/settings-ui-lib/static-1.12487",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7067",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11116",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9511",
  "unified-auth": "/unified-auth/static-1.444",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.725",
  "usage-tracker": "/usage-tracker/static-1.7304",
  "usage-tracker-core": "/usage-tracker-core/static-1.7154",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8049",
  "hub-http": "/hub-http/static-1.6188",
  "integrations-lib": "/integrations-lib/static-1.16005",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19588",
  "property-management-iframe": "/property-management-iframe/static-1.13026",
  "quartz-config": "/quartz-config/static-1.753",
  "quartz-core": "/quartz-core/static-1.6194",
  "quartz-routing": "/quartz-routing/static-1.405",
  "quick-fetch": "/quick-fetch/static-1.3887",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4617",
  "ts-schema": "/ts-schema/static-1.4049",
  "ui-universal-auth": "/ui-universal-auth/static-1.8930",
  "UIComponents": "/UIComponents/static-3.8375",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3375",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3252",
  "quartz-webpack": "/quartz-webpack/static-1.3199",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.53",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4128",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4824",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2099",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9395",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5315",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1753",
  "ui-fonts": "/ui-fonts/static-1.690",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2866",
  "foundations-theming-base": "/foundations-theming-base/static-1.3368",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.742",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3092",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4292",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8846",
  "ai-rendering-library": "/ai-rendering-library/static-1.9998",
  "chirp-fetch": "/chirp-fetch/static-1.1853",
  "connections-embed-lib": "/connections-embed-lib/static-1.926",
  "copilot-toolkit": "/copilot-toolkit/static-1.11039",
  "feedback-loader": "/feedback-loader/static-1.29229",
  "laboratory-lib": "/laboratory-lib/static-3.7125",
  "marketplace-embed": "/marketplace-embed/static-1.21978",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9484",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19544",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13759",
  "sanitize-text": "/sanitize-text/static-1.8109",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8664",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5718",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4990",
  "wootric-nps": "/wootric-nps/static-1.6950",
  "quartz-head": "/quartz-head/static-1.640",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4616",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4120",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2481",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.64",
  "cssUtils": "/cssUtils/static-1.782",
  "flux-actions": "/flux-actions/static-1.331",
  "HubStyle": "/HubStyle/static-2.11736",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10177",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10337",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7294",
  "icons": "/icons/static-2.644",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18121",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4481",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5342",
  "quartz-i18n": "/quartz-i18n/static-1.650",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.131",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.248",
  "fsm": "/fsm/static-1.3698",
  "customer-data-objects": "/customer-data-objects/static-1.7629",
  "property-translator": "/property-translator/static-1.5367",
  "hs-locale-management": "/hs-locale-management/static-1.55",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7895",
  "hs-promise-utils": "/hs-promise-utils/static-1.5559",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4842",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13420",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5565",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7749",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4438",
  "superstore": "/superstore/static-1.4732",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10118",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7826",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4623",
  "immutable-less": "/immutable-less/static-1.4615",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16995",
  "nav-meta": "/nav-meta/static-1.29553",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10212",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17936",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3811",
  "property-management-common": "/property-management-common/static-1.5314",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9024",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.516",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.650",
  "quartz-test": "/quartz-test/static-1.650",
  "quartz-tracking": "/quartz-tracking/static-1.354",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.27",
  "bender-build-tools": "/bender-build-tools/static-1.3147",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3561",
  "persist-promise": "/persist-promise/static-1.3667",
  "reference-resolvers": "/reference-resolvers/static-1.8136",
  "transmute": "/transmute/static-2.85",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21125",
  "ContentUtils": "/ContentUtils/static-1.68256",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12992",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2465",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39631",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13126",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14231",
  "ExportDialog": "/ExportDialog/static-6.10360",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41202",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.64",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.64",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.64",
  "ui-addon-teams": "/ui-addon-teams/static-1.21499",
  "magpie-lib": "/magpie-lib/static-1.5536",
  "navigation-components": "/navigation-components/static-1.17916",
  "magpie-types": "/magpie-types/static-1.4996",
  "simple-logging-lib": "/simple-logging-lib/static-1.3015",
  "ai-studio-lib": "/ai-studio-lib/static-1.11504",
  "app-governance-lib": "/app-governance-lib/static-1.1434",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10476",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7963",
  "ui-product-approvals": "/ui-product-approvals/static-1.28031",
  "ui-tool-access": "/ui-tool-access/static-1.10116",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8702",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5721",
  "usage-tracker-public": "/usage-tracker-public/static-1.7115",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3892",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.301",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2979",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2674",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "atom": "/atom/static-1.5038",
  "purchase-motions-components": "/purchase-motions-components/static-1.5817",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1510",
  "crm-component-utils": "/crm-component-utils/static-1.38988",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5842",
  "customer-data-properties": "/customer-data-properties/static-1.51423",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6846",
  "property-value-citations": "/property-value-citations/static-1.2037",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8061",
  "navigation-messaging": "/navigation-messaging/static-1.7243",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9873",
  "growth-payments-core": "/growth-payments-core/static-1.25271",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13568",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7215",
  "crm-message-bus": "/crm-message-bus/static-1.42895",
  "reporting-plugins": "/reporting-plugins/static-1.10258",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.64",
  "cms-field-types": "/cms-field-types/static-1.4778",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9793",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22066",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4685",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3980",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6751",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.945",
  "onboarding-tours": "/onboarding-tours/static-1.16529",
  "academy-common-lib": "/academy-common-lib/static-1.13691",
  "content-assistance-lib": "/content-assistance-lib/static-1.7696",
  "dashboard-lib": "/dashboard-lib/static-1.81388",
  "file-manager-components": "/file-manager-components/static-1.23517",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18402",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18145",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18137",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19768",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8664",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4735",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10977",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9015",
  "user-context": "/user-context/static-1.5069",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.689",
  "nest": "/nest/static-1.193",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10592",
  "framework-listing-lib": "/framework-listing-lib/static-2.28590",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30631",
  "apps-service-types": "/apps-service-types/static-1.3844",
  "oauth-service-types": "/oauth-service-types/static-1.4217",
  "onboarding-scopes": "/onboarding-scopes/static-1.6428",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4743",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7644",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14875",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3579",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9145",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5820",
  "signup-constants": "/signup-constants/static-1.18780",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8007",
  "trials-service-types": "/trials-service-types/static-1.3870",
  "card-properties-lib": "/card-properties-lib/static-1.44072",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37004",
  "crm-actions": "/crm-actions/static-1.6288",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43477",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9202",
  "customer-data-tracking": "/customer-data-tracking/static-1.6852",
  "hs-resources": "/hs-resources/static-1.117",
  "pulse": "/pulse/static-1.530",
  "calling-global-api": "/calling-global-api/static-1.64389",
  "calling-internal-common": "/calling-internal-common/static-1.31268",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65771",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58065",
  "commerce-products-lib": "/commerce-products-lib/static-1.9410",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3768",
  "crm-links": "/crm-links/static-1.6251",
  "external-options-client-types": "/external-options-client-types/static-1.4129",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4194",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.598",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3662",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48617",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3936",
  "smart-property-lib": "/smart-property-lib/static-1.6738",
  "tiered-pricing": "/tiered-pricing/static-1.1127",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10954",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4113",
  "ui-addon-opt": "/ui-addon-opt/static-4.8337",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8989",
  "react-dnd-compat": "/react-dnd-compat/static-1.4586",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5371",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3033",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1818",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.595",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7499",
  "academy-service-client": "/academy-service-client/static-1.3649",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39016",
  "FileManagerLib": "/FileManagerLib/static-1.39157",
  "video-embed": "/video-embed/static-1.35643",
  "zustand": "/zustand/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28446",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11151",
  "video-data-lib": "/video-data-lib/static-1.34809",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23435",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9854",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24292",
  "viral-links-lib": "/viral-links-lib/static-1.7022",
  "data-token-picker": "/data-token-picker/static-1.16342",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.191",
  "timezone-utils": "/timezone-utils/static-2.5211",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17520",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7291",
  "customer-data-views-management": "/customer-data-views-management/static-1.25380",
  "framework-data-table": "/framework-data-table/static-2.11834",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6818",
  "nudge-client-utils": "/nudge-client-utils/static-1.2484",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.970",
  "app-users-service-client": "/app-users-service-client/static-1.5560",
  "app-users-service-types": "/app-users-service-types/static-1.4968",
  "mini-checkout-client": "/mini-checkout-client/static-1.26714",
  "onboarding-utils": "/onboarding-utils/static-1.5319",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2044",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28431",
  "edison-service-client-types": "/edison-service-client-types/static-1.354",
  "crm_data": "/crm_data/static-4.91846",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45911",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15856",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18963",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18429",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10274",
  "crm-fe-perf": "/crm-fe-perf/static-1.22869",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.33",
  "directed-graph": "/directed-graph/static-1.901",
  "event-emitter": "/event-emitter/static-1.914",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31274",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11004",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6509",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.841",
  "commerce-permissions": "/commerce-permissions/static-1.732",
  "products-iframe-lib": "/products-iframe-lib/static-1.7834",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10257",
  "data-agent-kit": "/data-agent-kit/static-1.136",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9958",
  "policy-lib": "/policy-lib/static-1.6740",
  "react-tinymce": "/react-tinymce/static-1.55138",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10021",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54264",
  "tinymce-plugins": "/tinymce-plugins/static-1.57378",
  "tinymce-themes": "/tinymce-themes/static-1.56234",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.489",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1901",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1846",
  "user-context-client": "/user-context-client/static-1.4578",
  "audio-components": "/audio-components/static-1.5861",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36668",
  "urlinator": "/urlinator/static-1.4497",
  "video-components": "/video-components/static-1.13154",
  "outpost": "/outpost/static-1.4152",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6549",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12136",
  "content-media-compositions": "/content-media-compositions/static-2.16143",
  "media-bridge-lib": "/media-bridge-lib/static-1.18864",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6026",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5049",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3606",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21608",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3810",
  "ts-utils-lib": "/ts-utils-lib/static-1.139",
  "crm-export-dialog": "/crm-export-dialog/static-1.6265",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6405",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1878",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2241",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2560",
  "whisper-core-api": "/whisper-core-api/static-1.6510",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14714",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5422",
  "settings-content-modals": "/settings-content-modals/static-1.45975",
  "crm_universal": "/crm_universal/static-1.21943",
  "customer-data-email": "/customer-data-email/static-1.17970",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37064",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39427",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11917",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54606",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21370",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17694",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71879",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5305",
  "utility-belt": "/utility-belt/static-1.2503",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22634",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7439",
  "customer-data-rte": "/customer-data-rte/static-1.32897",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5653",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5075",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.37969",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35618",
  "sales-views-client-types": "/sales-views-client-types/static-1.4231",
  "hub-http-contrib": "/hub-http-contrib/static-1.3006",
  "interframe": "/interframe/static-3.4727",
  "tinymce-data": "/tinymce-data/static-1.40349",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5177",
  "layout-dnd-components": "/layout-dnd-components/static-1.12373",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11348",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15113",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9033",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.21995",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1882",
  "checkout-sdk": "/checkout-sdk/static-3.23557",
  "checkout-service-types": "/checkout-service-types/static-1.3797",
  "company-details-components": "/company-details-components/static-1.6163",
  "payment-method-components": "/payment-method-components/static-1.6879",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13763",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3442",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3491",
  "access-control-lib": "/access-control-lib/static-1.10403",
  "EmailComponents": "/EmailComponents/static-1.54674",
  "EmailData": "/EmailData/static-1.53351",
  "redux-less": "/redux-less/static-2.9449",
  "sequences-lib": "/sequences-lib/static-1.7977",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10314",
  "products-ui-components": "/products-ui-components/static-1.39929",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7006",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54622",
  "commerce-products-api": "/commerce-products-api/static-1.2233",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56680",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102557",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80600",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28165",
  "ContentData": "/ContentData/static-1.68331",
  "layout-data-lib": "/layout-data-lib/static-1.9673",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.794",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3899",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3957",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.525",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18529",
  "pricing-pages-api": "/pricing-pages-api/static-1.13628",
  "ContentComponents": "/ContentComponents/static-2.71212",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9876",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1897",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46158",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1020",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18764",
  "automation-ui-types": "/automation-ui-types/static-1.19682",
  "messaging-types-lib": "/messaging-types-lib/static-1.45895",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4469",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7834",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.490",
  "price-books-api": "/price-books-api/static-1.526",
  "price-books-components": "/price-books-components/static-1.584",
  "property-description-translator": "/property-description-translator/static-1.3812",
  "ramp-editor": "/ramp-editor/static-1.61",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3594",
  "totals-ui-components": "/totals-ui-components/static-1.23494",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9188",
  "advanced-menus-core": "/advanced-menus-core/static-1.15072",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12019",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33946",
  "segments-query-core": "/segments-query-core/static-1.1380",
  "demographics-service-types": "/demographics-service-types/static-1.1619",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3151",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5598",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7305",
  "data-token-views": "/data-token-views/static-1.16323",
  "forms-utils-lib": "/forms-utils-lib/static-1.12510",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12953",
  "simple-menus-core": "/simple-menus-core/static-1.15071",
  "simple-menus-lib": "/simple-menus-lib/static-1.16588",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4221",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6765",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7484",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3469",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2570",
  "ContentEditorUI": "/ContentEditorUI/static-2.77014",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3948",
  "web-interactives-components": "/web-interactives-components/static-1.13697",
  "web-interactives-data": "/web-interactives-data/static-1.13698",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.469",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.639",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.943",
  "line-items-api": "/line-items-api/static-1.634",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3789",
  "FireAlarmUi": "/FireAlarmUi/static-1.4484",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4139",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21618",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21081",
  "data-studio-ubb": "/data-studio-ubb/static-1.2612",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26937",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57694",
  "content-management-data-lib": "/content-management-data-lib/static-1.5339",
  "copilot-plugins": "/copilot-plugins/static-1.11012",
  "cta-picker": "/cta-picker/static-1.36303",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2986",
  "editor-components": "/editor-components/static-1.13179",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8351",
  "error-messaging-js": "/error-messaging-js/static-1.5158",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85743",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10612",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1713",
  "smart-content-core": "/smart-content-core/static-1.42335",
  "smart-content-lib": "/smart-content-lib/static-1.42988",
  "social-composer-lib": "/social-composer-lib/static-1.58954",
  "structured-content-lib": "/structured-content-lib/static-1.25093",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53151",
  "tinymce-copilot": "/tinymce-copilot/static-1.16332",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7851",
  "automation-ui-routing": "/automation-ui-routing/static-1.21039",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5606",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42112",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3139",
  "reporting-enablement": "/reporting-enablement/static-1.22791",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21116",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2491",
  "forms-ai-lib": "/forms-ai-lib/static-1.4259",
  "codemirror-dlb": "/codemirror-dlb/static-1.58573",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6396",
  "report-customization-components": "/report-customization-components/static-1.13060",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12880",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.242",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1636"
}
};
